import { render } from "./InputTypeText.vue?vue&type=template&id=72a5d194"
import script from "./InputTypeText.vue?vue&type=script&lang=js"
export * from "./InputTypeText.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__